import { FC, useState } from 'react';
import './style.scss';
import { Radio, Button, Modal } from 'antd';

const PromisePlugin: FC<any> = ({ status = false, promiseRadio = () => {}, next }) => {
    // const [open, setOpen] = useState(true);

    // function handleCancel() {
    //     setOpen(false);
    // }

    // function submit() {
    //     next(5);
    // }

    function toBar() {
        next(6, 'success', true);
    }

    return (
        <div className='promise-box'>
            <div className='text-title'>
                <span className='line'></span>
                <span style={{ marginRight: '35px' }}>承诺声明</span>
                <Button type='primary' size='large' onClick={toBar} style={{ background:"red"}}>
                查看医疗广告审查办件进度和下载医疗广告审批结果
                </Button>
            </div>
            <div className='text-title-line'></div>
            <div className='text-centent'>
                1.申请人应保证通过四川省网上办事大厅提交的申请材料和有关信息内容真实无误，否则造成不良后果的，由申请人承担。
                <br />
                2.申请人知晓为本次申办事项所提交材料系由该事项主管部门直接处理，并承诺所提交的信息真实无误。
                <br /> 3.申请人同意在本事项办理过程中采集、存储、使用、处理本人的个人信息。
                <br /> 4.申请人承诺已经取得办件过程中所涉及的第三人的个人信息的同意和委托。
                <br />
                5.网上申请提交成功后，审批部门将在8个工作日内完成网上预审。预审后如需补正材料的，按照补正流程进行；符合受理条件的，按照受理流程进行。有关重要信息将通过电话反馈、平台反馈等方式通知您。
            </div>
            <div>
            <div
                    style={{
                        textAlign: 'left',
                        fontSize: '16px',
                        color: 'green',
                        fontWeight: 'bold',
                        paddingLeft: '64px',
                        marginTop: '10px'
                    }}
                >
                    网上申请办理医疗广告审查不需现场取件，请在受理进度界面进行下载
                </div>
                <div
                    style={{
                        textAlign: 'left',
                        fontSize: '16px',
                        color: 'red',
                        fontWeight: 'bold',
                        paddingLeft: '64px',
                        marginTop: '10px'
                    }}
                >
                    咨询电话：86925131
                </div>
                <div
                    style={{
                        textAlign: 'left',
                        fontSize: '16px',
                        color: 'red',
                        fontWeight: 'bold',
                        paddingLeft: '64px',
                        marginTop: '10px'
                    }}
                >
                    咨询邮箱：swjwylgg2023@163.com
                </div>
                <div
                    style={{
                        textAlign: 'left',
                        fontSize: '16px',
                        color: 'green',
                        fontWeight: 'bold',
                        paddingLeft: '64px',
                        marginTop: '10px'
                    }}
                >
                    电话咨询时间：星期一至星期五（或者工作日） 上午：09:00-12:00 下午：13:00-17:00 （备注：法定节假日除外）
                </div>
            </div>
            <div className='radio-box'>
                <Radio defaultChecked={status} onChange={promiseRadio}>
                    <span className='text'> 我已阅读并确认上述《承诺和授权书》</span>
                </Radio>

                <div>
                    <Button
                        onClick={next.bind(null, 1)}
                        type='primary'
                        style={{ width: 140, marginTop: 15, height: 35 }}
                        disabled={!status}
                    >
                        下一步
                    </Button>
                </div>
            </div>
            {/* <Modal
                title={null}
                open={open}
                footer={null}
                onCancel={handleCancel}
                destroyOnClose={true}
                width={450}
                style={{ textAlign: 'center', top: '35%' }}
            >
                <div style={{ fontSize: '18px', fontWeight: 'bold' }}>
                    在线填报可以提高审核的准确率
                </div>
                <div
                    style={{
                        color: '#999',
                        fontSize: '16px',
                        marginBottom: '30px'
                    }}
                >
                    打印盖章后可直接用于材料审核
                </div>
                <Button
                    type='primary'
                    onClick={handleCancel}
                    ghost
                    style={{ width: '300px', textAlign: 'left' }}
                >
                    1、去填写《申请表》
                </Button>
                <Button
                    type='default'
                    onClick={submit}
                    style={{ width: '300px', marginTop: '15px', textAlign: 'left' }}
                >
                    2、已填写《申请表》并盖章，提交部门审查
                </Button>
            </Modal> */}
        </div>
    );
};

export default PromisePlugin;
